export default {
  sectionLineItemAudits: [],
  sectionLineItemAudit: undefined,
};
